/* eslint-disable */
import { useEffect } from 'react';
var useLifecycles = function (mount, unmount) {
    useEffect(function () {
        if (mount) {
            mount();
        }
        return function () {
            if (unmount) {
                unmount();
            }
        };
    }, []);
};
export default useLifecycles;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-use/esm/useLifecycles.js
// module id = null
// module chunks = 